module.exports = __webpack_public_path__ + "public/img/hubvet_logo.df1b7dc1.svg";